<div class="select-days">
	<div class="sd-title">
		<bp-button size="sm" variant="lightest" (click)="handleCancel()">Cancel</bp-button>
		<span>{{ data.flexPeriod?.name ?? 'Add Sessions' }}</span>
		<bp-button variant="color" size="sm" (click)="handleSubmit()" [disabled]="!anySelected">Save</bp-button>
	</div>
	<div class="sd-list">
		<ng-container *ngFor="let schedule of options">
			<div *ngIf="!schedule.hidden" class="sd-option" [ngClass]="schedule.selected ? 'selected' : ''" (click)="toggle(schedule.start)">
				<div>
					<img *ngIf="schedule.selected" [src]="'./assets/Check (Green).svg' | resolveAsset" alt="Checked" />
				</div>
				<span>{{ schedule.start | date : 'EEEE, MMMM d' }}</span>
				<span>{{ schedule.start | date : 'h:mm a' }} - {{ schedule.end | date : 'h:mm a' }}</span>
			</div>
		</ng-container>
	</div>
	<div class="sd-footer">
		<span>Select all</span>
		<form [formGroup]="selectDaysForm">
			<app-toggle-input
				[form]="selectDaysForm"
				[controlName]="'toggle'"
				[controlSize]="'small'"
				(pushOutValue)="onEnabledToggle($event)"
				[delimiter]="false"></app-toggle-input>
		</form>
	</div>
</div>
